import { AspectRatio, Image } from "@chakra-ui/react";
import generateAdminPath from "../../../libraries/utils/generateAdminPath";
import PampaImage from "../../PampaImage";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Holder").Holder} holder
 * @property {number} [maxW]
 *
 * @param {Props & import("@chakra-ui/react").BoxProps} props
 */
function HoldersAvatar({ holder, maxW = 32, ...otherProps }) {
  return (
    <AspectRatio
      ratio={10 / 14}
      w={`${maxW + 2}px`}
      maxW={`${maxW}px`}
      display="block"
      borderWidth="1px"
      borderRadius="6px"
      overflow="hidden"
      margin="auto"
      {...otherProps}>
      {holder.id_card ? (
        <PampaImage
          image={holder.id_card}
          maxContainerWidth={maxW}
          mode="crop"
          format="default"
          margin="auto"
          alt={`${holder.first_name} ${holder.last_name}`}
        />
      ) : (
        <Image
          src={generateAdminPath({
            id: "internal-assets",
            parameters: { filePath: "placeholder-user.svg" },
            includeBasePath: true,
          })}
          margin="auto"
          alt={`${holder.first_name} ${holder.last_name}`}
        />
      )}
    </AspectRatio>
  );
}

export default HoldersAvatar;
